/* Lazy autoplay for decorative videos.

   Videos marked data-lazy-autoplay render with preload="none" and without the
   autoplay attribute, so the browser fetches nothing at page load. This script
   starts them when they come within 200px of the viewport, pauses them when they
   leave it or when the tab is hidden, and resumes when they are back. Without
   IntersectionObserver it simply plays them, which is the old behaviour.

   Measured before this: the Reglow PDP pulled a 103 MB autoplay video and the home
   page 2 to 4 MB of HLS segments on every visit, all for sections below the fold. */
(function () {
  'use strict';
  var inView = new Set();

  function play(v) {
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function observeAll(root) {
    var vids = (root || document).querySelectorAll('video[data-lazy-autoplay]:not([data-lazy-bound])');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.setAttribute('data-lazy-bound', ''); play(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          inView.add(v);
          if (!document.hidden) play(v);
        } else {
          inView.delete(v);
          if (!v.paused) v.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { v.setAttribute('data-lazy-bound', ''); io.observe(v); });
  }

  document.addEventListener('visibilitychange', function () {
    inView.forEach(function (v) {
      if (document.hidden) { if (!v.paused) v.pause(); }
      else play(v);
    });
  });

  /* Theme editor re-renders sections; bind any video it adds. */
  document.addEventListener('shopify:section:load', function (e) { observeAll(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeAll(); });
  } else {
    observeAll();
  }
})();
